/**
 * Relance programmée à l'envoi d'un devis (aperçu du devis PDF).
 *
 * Le commercial choisit, s'il le veut, quand il sera rappelé de relancer le
 * client. Les délais se comptent à partir de la date d'envoi du devis.
 * Partagé entre le choix à l'écran et la création des tâches côté serveur.
 */
export const QuoteRelanceMode = {
  J7: 'j7',
  J21: 'j21',
  J7_J21: 'j7_j21',
  DATE: 'date',
};

export const QUOTE_RELANCE_MODES = Object.values(QuoteRelanceMode);

/** Délais en jours après l'envoi, par choix ; vide pour une date choisie. */
export const QUOTE_RELANCE_OFFSETS = {
  [QuoteRelanceMode.J7]: [7],
  [QuoteRelanceMode.J21]: [21],
  [QuoteRelanceMode.J7_J21]: [7, 21],
  [QuoteRelanceMode.DATE]: [],
};

export const QUOTE_RELANCE_LABELS = {
  [QuoteRelanceMode.J7]: 'Dans 7 jours',
  [QuoteRelanceMode.J21]: 'Dans 21 jours',
  [QuoteRelanceMode.J7_J21]: 'Dans 7 jours et dans 21 jours',
  [QuoteRelanceMode.DATE]: 'Choisir une date',
};

export const QUOTE_RELANCE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Un devis sans signature passe automatiquement en « Devis perdu » ce nombre de
 * jours après son envoi, et ses relances disparaissent avec lui. Une relance à
 * une date choisie tombe donc au plus tard la veille.
 */
export const QUOTE_AUTO_LOSS_DAYS = 30;
export const QUOTE_RELANCE_MAX_DAYS = QUOTE_AUTO_LOSS_DAYS - 1;
